// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__t6pg3","plus":"styles_plus__m6fL_","key":"styles_key__ELu5H"};